<template>
  <v-card :loading="loading" flat>
    <v-card-title class="align-content-center justify-content-center">
      لیست کلیه تراکنش ها
    </v-card-title>

    <div class="pa-4">
      <vue-table
        :data="transactionData"
        :headers="headers"
        :loading.sync="loading"
        :props.sync="tableProps"
        @change="onPagination"
      >
        <template v-slot:filters="{ props, perPage }">
          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
              <v-select
                v-model="props.length"
                :items="perPage"
                class="rounded-lg"
                dense
                hide-details
                label="تعداد نمایش"
                outlined
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
              <v-text-field
                v-model="searchInput"
                @keyup.enter="executeSearch"
                @click:append="executeSearch"
                @click:clear="clearSearch"
                append-icon="mdi-magnify"
                class="rounded-lg"
                clearable
                dense
                hide-details
                label="جستجو"
                outlined
              />
            </v-col>

            <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
              <date-picker
                v-model="props.dateFrom"
                clearable
                display-format="jYYYY-jMM-jDD"
                format="YYYY-MM-DD"
                label="از تاریخ"
              />
            </v-col>

            <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
              <date-picker
                v-model="props.toDate"
                clearable
                display-format="jYYYY-jMM-jDD"
                format="YYYY-MM-DD"
                label="تا تاریخ"
              />
            </v-col>

            <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
              <v-select
                v-model="props.type"
                :items="types"
                :menu-props="{ offsetY: true }"
                class="rounded-lg"
                clearable
                dense
                hide-details
                label="نوع"
                outlined
              />
            </v-col>

            <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
              <v-autocomplete
                v-model="props.productId"
                :items="products"
                chips
                class="rounded-lg"
                clearable
                dense
                hide-details
                item-text="description"
                item-value="uniqueId"
                label="انتخاب محصول"
                multiple
                outlined
                small-chips
              />
            </v-col>

            <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
              <user-picker v-model="props.userId" />
            </v-col>
           <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
              <v-text-field
                v-model="descInput"
                append-icon="mdi-magnify"
                @click:append="props.description = descInput; getTransactions()"
                @keyup.enter="props.description = descInput; getTransactions()"
                @click:clear="descInput = ''; props.description = ''; getTransactions()"
                class="rounded-lg"
                clearable
                dense
                hide-details
                label="توضیحات"
                outlined
              />
            </v-col>

            <v-col class="pa-2" cols="12" lg="3" md="4" sm="6">
              <v-text-field
                :value="props.transactionId"
                @change="props.transactionId = $event"
                @click:clear="props.transactionId = ''"
                class="rounded-lg"
                clearable
                dense
                hide-details
                label="شناسه تراکنش"
                outlined
              />
            </v-col>

            <v-col class="pa-2 d-flex" cols="12" lg="3" md="4" sm="6">
              <v-btn class="btn-report my-0" @click="factor"
                >ایجاد فاکتور</v-btn
              >

              <v-btn class="btn-buy my-0" @click="goto('admin/products')"
                >محصولات</v-btn
              >
            </v-col>
          </v-row>
        </template>

        <template v-slot:index="{ item }">
          {{
            item.index +
            1 +
            (transactionData.current_page - 1) * transactionData.per_page
          }}
        </template>

        <template v-slot:type="{ item }">
          <v-chip
            :color="$options.filters.transactionType(item.type).color"
            label
            outlined
            small
          >
            {{ $options.filters.transactionType(item.type).label }}
          </v-chip>
        </template>

        <template v-slot:amount="{ item }">
          <v-chip
            :color="item.state === 'increase' ? 'rgb(27,197,189)' : '#F64E60'"
            class="text-white"
            label
            small
          >
            {{ price(item.amount.$numberDecimal) }}
          </v-chip>
        </template>

        <template v-slot:balanceAfter="{ item }">
          {{ price(item.balanceAfter.$numberDecimal) }}
        </template>

        <template v-slot:serviceId="{ item }">
          <v-chip color="#6993ff" dark label small>
            {{ $options.filters.serviceTypeNumber(item.serviceId) }}
          </v-chip>
        </template>

        <template v-slot:createdAt="{ item }">
          {{ persian($options.filters.onlyDate(item.createdAt)) }}
        </template>

        <template v-slot:time="{ item }">
          {{ persian($options.filters.onlyTime(item.createdAt)) }}
        </template>

        <template v-slot:username="{ item }">
          {{ !!item.user ? item.user?.name + " " + item.user?.lastName : "-" }}
        </template>

        <template v-slot:description="{ item }">
          <div class="desc-html-wrapper" v-html="item.description" />
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <v-row
            class="mt-4 justify-center justify-content-center align-content-center"
          >
            <v-col class="ml-2" cols="6">
              <v-btn @click="refundTransactionDialog(true, item._id, 0)"
                >بازگشت کل وجه
              </v-btn>
            </v-col>
            <v-col class="mb-5" cols="6">
              <v-btn @click="refundTransactionDialog(false, item._id, count)"
                >بازگشت وجه با تعداد
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </vue-table>
    </div>

    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-flex v-if="!allPrice" class="pa-2" lg12 md12 sm12 xl12 xs12>
                <v-text-field
                  v-model="count"
                  dense
                  label="تعداد"
                  outlined
                  type="number"
                  
                />
              </v-flex>
            </v-row>

            <v-row>
              <v-flex class="pa-2" lg12 md12 sm12 xl12 xs12>
                <v-btn class="btn-submit" @click="refundTransaction"
                  >بازگشت وجه</v-btn
                >
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import walletButton from "./transactions/WalletOpenButton.vue";
import userPicker from "@/view/pages/pickers/userPicker.vue";
import CustomDatePicker from "@/view/content/pickers/custom-date-picker";

export default {
  name: "newWalletAdmin",

  components: {
    CustomDatePicker,
    userPicker,
    walletButton,
  },

  data() {
    return {
      descInput: '',
      searchInput: '',
      queries: {
        type: "",
        userId: "",
        createdAt: "",
      },
      types: [
        // { value: "online", text: "" },
        { value: "adminCharge", text: "" },
        { value: "refund", text: "" },
        { value: "agency", text: ""},
        { value: "withdraw", text: "" },
        { value: "charge", text: "" },
      ],
      // walletData: {
      //   balance: 0,
      // },
      transactionData: {},
      data: [],
      dialog: false,
      productsList: "",
      allPrice: false,
      editCons: {
        title: "بازگشت وجه",
        buttons: [
          { text: "", type: "submit", handler: this.refundTransaction },
        ],
      },
      loading: false,
      products: [],
      headers: [
        { text: "ردیف", value: "index", align: "center", sortable: false },
        { text: "شناسه", value: "uniqueId", align: "center", sortable: false },
        { text: "مبلغ", value: "amount", align: "center", sortable: false },
        { text: "تاریخ", value: "createdAt", align: "center", sortable: false },
        { text: "ساعت", value: "time", align: "center", sortable: false },
        {
          text: "نام سرویس",
          value: "serviceId",
          align: "center",
          sortable: false,
        },
        {
          text: "شناسه محصول",
          value: "productId",
          align: "center",
          sortable: false,
        },
        {
          text: "شناسه کاربری",
          value: "userId",
          align: "center",
          sortable: false,
        },
        { text: "نام", value: "username", align: "center", sortable: false },
        {
          text: "توضیحات",
          value: "description",
          align: "center",
          sortable: false,
        },
        { text: "تعداد", value: "count", align: "center", sortable: false },
        {
          text: "نام محصول",
          value: "product.description",
          align: "center",
          sortable: false,
        },
        { text: "نوع تراکنش", value: "type", align: "center", sortable: false },
        {
          text: "مانده موجودی",
          value: "balanceAfter",
          align: "center",
          sortable: false,
        },
      ],
      tableProps: {
        transactionId:null,
        search: "",
        length: 10,
        productId: [],
        column: "id",
        dir: "desc",
        page: 1,
        product:"", 
        type:'',
         dateFrom:null, 
         toDate:null,
          userId:'', 
          token:null,
          description:''
      },
      count: 0,
      urlNotif: "notificationAdmin",
    };
  },

  mounted() {
    this.getToken();
    this.updateTranslations();
    this.getTransactions();
  },

  methods: {
     executeSearch() {
      this.tableProps.search = this.searchInput;
      this.getTransactions();
    },
    clearSearch() {
      this.searchInput = '';
      this.tableProps.search = "";
      this.$nextTick(() => {
        this.getTransactions();
      });

    },
    clearSearch() {
      this.tableProps.search = '';
      this.getTransactions();
    },
        updateTranslations() {
      this.types = [

        // {
        //   value: "online",
        //   text: this.$t("newUserTransactions.transactionTypes.online"),
        // },
        {
          value: "adminCharge",
          text: this.$t("newUserTransactions.transactionTypes.admin"),
        },
        {
          value: "refund",
          text: this.$t("newUserTransactions.transactionTypes.refund"),
        },
        {
          value: "agency",
          text: this.$t("newUserTransactions.transactionTypes.agency"),
        },
        {
          value: "withdraw",
          text: this.$t("newUserTransactions.transactionTypes.withdraw"),
        },
        {       

          value: "charge",
          text: this.$t("newUserTransactions.transactionTypes.deposit"),
        },
      ];
      },
    fetchProducts() {
      this.loading = true;

      this.requestApiGetWallet(`product`)
        .then(({ data }) => {
          this.products = data.data;
          this.loading = false;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات محصول از کیف پول");
        });
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };

      this.getTransactions(props);
    },
    getDate(val, type = "date") {
      let moment = require("moment-jalaali");

      const date = new Date();
      date.setTime(val);

      const year = date.getFullYear();
      const month = date.getMonth() + 1; // Note: January is 0
      const day = date.getDate();
      const formattedDate = `${year}-${month}-${day}`;
      const time = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;

      if (type === "date") return moment(formattedDate).format("jYYYY-jM-jD");

      let t = formattedDate + " " + time;
      return moment(t).format("HH:mm:ss");
    },
    refundTransactionDialog(allPrice, transactionId, count) {
      this.dialog = true;
      this.allPrice = allPrice;
      this.transactionId = transactionId;
      this.count = count;
    },
    refundTransaction() {
      let data = {};
      if (this.count === 0) {
        data = {
          transactionId: this.transactionId,
        };
      } else {
        data = {
          transactionId: this.transactionId,
          count: this.count,
        };
      }

      this.requestApiPostWallet("transactions/refund", data)
        .then(({ data }) => {
          this.loading = false;
          this.$toast.success("بازگشت وجه با موفقیت انجام شد");
          this.getTransactions();
          this.dialog = false;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در انجام عملیات");
          this.loading = false;
        });
    },
    // async getWallet() {
    //   this.loading = true;
    //   await this.requestApiPostWallet('wallet').then(({data}) => {
    //     this.loading = false;
    //     this.walletData.balance = Number(data.data.balance.$numberDecimal)
    //   }).catch(({response}) => {
    //     this.loading = false;
    //   })
    // },
    // selectProducts(e) {
    //   console.log(e)
    //   // this.tableProps.productId = $e
    // },
    getToken(){
       this.requestApiGet("user/jwt").then(({data})=>{
        this.tableProps.token = data.data.token;
        
      }).catch(({response})=>{
        this.$toast.error("فرایند ساخت فاکتور با مشکل روبرو شده مجدد سعی کنید")
      }) .finally(() => {});
    },
    getTransactions(query = this.tableProps) {
      this.loading = true;

      if (query.productId) query.product = this.tableProps.productId.join(",");
      if (query.userId) query.userId = this.tableProps.userId.join(",");

      // console.log(query)
     
      this.requestApiGet("admin/newWallet/transactions", query)
        .then(({ data }) => {
          this.transactionData = data.data;
          this.fetchProducts();
        })
        .catch(({ response }) =>
          console.log("failed to get admin wallet transactions: ", response)
        )
        .finally(() => (this.loading = false));
    },
    redirectTo() {
      if (this.count === 0) this.$toast.info("درحال بروزرسانی ...");
      if (this.count === 1) this.$toast.warning("درحال بروزرسانی ...");
      this.count++;
    },
    encodeQueryData(data) {
      const ret = [];
      for (const d in data) {
        if (!data[d]) continue;
        else if (typeof data[d] === "object") data[d] = data[d].join(",");

        ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
      }
      return ret.join("&");
    },
  factor() {
           this.requestApiGet("user/jwt").then(({data})=>{
        this.tableProps.token = data.data.token;
        let { productId, type, dateFrom, toDate, userId, token,description } = this.tableProps;      
      let user_id = Array.isArray(userId) ? userId[0] : (userId ? String(userId).split(',')[0] : '');
  const link =
    `${this.$coreApi2}/admin/newWallet/generateFactor?` +
    this.encodeQueryData({
      product: productId, 
      type,
      dateFrom,
      toDate,
      userId:user_id,
      token,
      desc:description
    });
  window.open(link, "_blank");
      }).catch(({response})=>{
        this.$toast.error("فرایند ساخت توکن با مشکل روبرو شده مجدد سعی کنید")
      }) .finally(() => {});

      
  },
}
};
</script>

<style scoped>
.desc-html-wrapper >>> a {
  padding: 2px 4px;
  margin: 2px;
  display: inline-block;
  background-color: skyblue;
  border-radius: 4px;
  transition: background-color 0.1s ease-in;
}

.desc-html-wrapper >>> a:hover {
  background-color: #2ea0ec;
}

pre {
  outline: 1px solid #ccc;
  padding: 5px;
  margin: 5px;
  background-color: #282828;
  color: white;
}

.string {
  color: green !important;
}

.number {
  color: darkorange !important;
}

.boolean {
  color: blue !important;
}

.null {
  color: magenta !important;
}

.key {
  color: red !important;
}
</style>
